import { useEffect, useState } from "react";
import useAxiosInstance from "../lib/useAxiosInstance";

// Tells the navbars which of the three report buttons (PIU Playbook,
// Election Mode Playbook, SIR Report) actually have data for the logged-in
// client, so a button is never shown for a report the client doesn't have.
const useReportsAccess = () => {
  const axiosInstance = useAxiosInstance();
  const [hasPiuPlaybook, setHasPiuPlaybook] = useState(false);
  const [hasElectionModePlaybook, setHasElectionModePlaybook] = useState(false);

  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;
  const sirReport = (user?.powerBiLinks || []).find((r) => r.type === "sir");

  useEffect(() => {
    let cancelled = false;

    const fetchAvailability = async () => {
      try {
        const res = await axiosInstance.get("api/playbook/my-playbook/exists");
        const data = res?.data?.data || {};
        if (!cancelled) {
          setHasPiuPlaybook(!!data.hasPiuPlaybook);
          setHasElectionModePlaybook(!!data.hasElectionModePlaybook);
        }
      } catch (error) {
        if (!cancelled) {
          setHasPiuPlaybook(false);
          setHasElectionModePlaybook(false);
        }
      }
    };

    fetchAvailability();
    return () => {
      cancelled = true;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { hasPiuPlaybook, hasElectionModePlaybook, sirReport };
};

export default useReportsAccess;
